'use client';
import { useState, useEffect } from 'react';
import { auth } from '../../../fire-base/FirebaseAuth';
import type { FormInstance } from 'antd';
import { Button, Checkbox, Form, Input } from 'antd';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { emailPattern, passwordPattern, requiredTextField } from '../../../utils/FormValidations';
import Link from 'next/link';
import { appAction } from '@/store/store';
import { useRouter } from 'next/navigation';
import {
  GoogleAuthProvider,
  OAuthProvider,
  createUserWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth';
import { TNCs, Description, UserAggrement } from './termAndConditions';

import '../style.scss';
import { user } from '@/model/authModel/AuthModel';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { toaster } from '@/utils/toast';
type Props = {
  userAggrementModalOpen: boolean;
  userAggrementModalClose: any;
  footer: boolean;
};

const TermAndUserAggrementsModal = ({
  userAggrementModalOpen,
  userAggrementModalClose,
  footer,
}: Props) => {
  const [activeSection, setActiveSection] = useState('section1');
  return (
    <>
      <Modal
        className="commonModal"
        show={userAggrementModalOpen}
        onHide={() => userAggrementModalClose('hide')}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms of Service</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="user-aggrement-modal">
            <Row>
              <Col sm={12}>
                <div className="contentPart customScroll">
                  {Description.map((val, index) => (
                    <div key={index} id={val.id}>
                      <h6 style={{ marginTop: '10px', color: 'black' }}> {`${val.id}`} </h6>
                      <p> {val.desc} </p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        {footer ? (
          <Modal.Footer>
            <Button className="secondaryButton" onClick={() => userAggrementModalClose('disagree')}>
              Disagree
            </Button>
            <Button className="primaryButton" onClick={() => userAggrementModalClose('agree')}>
              Agree
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal>
    </>
  );
};

export default TermAndUserAggrementsModal;
